// web/src/lib/allowlist.ts
// Tester-access gate: an account may use the app only if allowlist/{lowercased-email}
// exists in Firestore. Testers are added/removed in the Firebase console — no redeploy.
// This client check is the UX layer (block sign-in, evict restored sessions); the REAL
// enforcement lives in firestore.rules + storage.rules (same doc, checked server-side —
// storage upload gating means no photo/deck generation flow without being listed).
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";

/** True iff this email is on the tester allowlist. Fails CLOSED on errors. */
export async function isAllowlisted(email: string | null | undefined): Promise<boolean> {
  if (!email) return false;
  // Local emulator dev: no allowlist docs seeded — don't lock developers out.
  if (import.meta.env.VITE_USE_EMULATORS === "1") return true;
  try {
    const snap = await getDoc(doc(db, "allowlist", email.toLowerCase()));
    return snap.exists();
  } catch (e) {
    console.warn("[allowlist] check failed — denying access", e);
    return false;
  }
}
